import { createContext, FC, useState } from 'react'

export type ContextState = {
  showNotifyUser: boolean
  setShowNotifyUser: (val: boolean) => void
  showContactSupport: boolean
  setShowContactSupport: (val: boolean) => void
  selectedProjects: Project[]
  setSelectedProjects: (val: Project[]) => void
  showPromoCodeModal: boolean
  setShowPromoCodeModal: (val: boolean) => void
}

const contextDefaultValues: ContextState = {
  showNotifyUser: false,
  setShowNotifyUser: () => {},
  showContactSupport: false,
  setShowContactSupport: () => {},
  selectedProjects: [],
  setSelectedProjects: () => {},
  showPromoCodeModal: false,
  setShowPromoCodeModal: () => {},
}

type Props = {
  children?: React.ReactNode
}

export const Context = createContext<ContextState>(contextDefaultValues)

const ProjectContextProvider: FC = ({ children }: Props) => {
  const [showNotifyUser, setShowNotifyUser] = useState(false)
  const [showContactSupport, setShowContactSupport] = useState(false)
  const [selectedProjects, setSelectedProjects] = useState<Project[]>([])
  const [showPromoCodeModal, setShowPromoCodeModal] = useState(false)

  return (
    <Context.Provider
      value={{
        showNotifyUser,
        setShowNotifyUser,
        showContactSupport,
        setShowContactSupport,
        selectedProjects,
        setSelectedProjects,
        showPromoCodeModal,
        setShowPromoCodeModal,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export default ProjectContextProvider
